export const QUESTION_ID_INDEX = 0;
export const RESPONSE_ID_INDEX = 1;
export const DEPENDENT_ID_INDEX = 2;

export const UNUM_PARENT_LOOKUPS = ["Employee_USCitizen", "Spouse_USCitizen"];
